import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import AlertService from "@/services/libs/AlertService";
import AuthService, { authServiceInstance } from "@/services/AuthService";
import { isProd, redirectToDataScout } from "@/services/libs/Utils";
import StorageService from "@/services/libs/StorageService";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  //base: process.env.BASE_URL,
  base: process.env.VUE_APP_PUBLIC_PATH,
  routes,
});

router.beforeEach((to, from, next) => {
  const ticket = to.query.ticket ? new String(to.query.ticket) : undefined;
  // if query contains a ticket
  if (ticket) {
    // validate ticket and redirect to main
    if (ticket)
      authServiceInstance.login(ticket.toString()).then(() => {
        // show success message
        AlertService.success("Angemeldet");
        const route = { path: "/" };
        if (next) next(route);
        else router.push(route);
        return;
      });
  }
  // if route requires auth, check if logged in
  else if (
    (to.matched.some((record) => record.meta.requiresAuth) &&
      !AuthService.isLoggedIn()) ||
    (to.matched.some((record) => record.meta.requiresWritePermission) &&
      !AuthService.hasWritePermission())
  ) {
    // if not, redirect to Home page.
    setLastRoute(from.name || "");
    AlertService.info(
      "Authentifizierung fehlgeschlagen, bitte zuerst anmelden!",
    );
    goToHome(next);
    return;
  }
  // does not require auth
  // go to wherever I'm going
  else next(); // make sure to always call next()!
});

let lastRoute = "";
/**
 * Change route to Home page
 */
function goToHome(next: Function | undefined = undefined): void {
  if (isProd()) {
    // redirect to datascout page after 0.5s
    console.debug("redirect to DataScout");
    setTimeout(redirectToDataScout, 500);
  } else if (router.currentRoute.name != "Home") {
    // else redirect to home route
    console.debug("redirect to Home");
    const route = { name: "Home" };
    if (next) next(route);
    else router.push(route);
  }
}

function logout(next: Function | undefined = undefined): void {
  if (isProd()) {
    // redirect to datascout page after 0.5s
    console.debug("redirect to DataScout");
    setTimeout(redirectToDataScout, 500);
  } else {
    // else redirect to home route
    console.debug("redirect to Login");
    const route = { name: "Login" };
    router.push(route);
  }
  StorageService.clear();
}

/**
 * changes route to last route befor login or to home page
 */
function goToLastRoute(): void {
  console.debug("redirect to last route");
  // redirect to last route if set
  if (lastRoute) router.push({ path: lastRoute });
  // else redirect to home
  else goToHome();
}

function setLastRoute(route: string): void {
  lastRoute = route;
}

export { goToHome, logout, goToLastRoute, setLastRoute };
export default router;
